import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface Collaborator {
  id?: string;
  userId?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  email?: string;
  phone?: string;
}

@Component({
    selector: 'app-collaborator-button',
  templateUrl: './collaborator-button.component.html',
  styleUrl: './collaborator-button.component.scss',
  standalone: false,
})
export class CollaboratorButtonComponent {
  @Input() collaborator: Collaborator | null = null;
  @Input() companyId?: string;
  @Input() showIcon: boolean = true;
  @Input() iconClass: string = 'bi bi-person-fill';
  @Input() buttonClass: string = 'user-badge';
  @Input() maxLength: number = 20;
  @Input() disabled: boolean = false;

  @Output() collaboratorClick = new EventEmitter<{ collaborator: Collaborator; companyId?: string; event?: Event }>();

  /**
   * Formate le nom du collaborateur
   */
  getFormattedName(): string {
    if (!this.collaborator) {
      return '';
    }

    let fullName = '';
    
    if (this.collaborator.firstName && this.collaborator.lastName) {
      fullName = this.collaborator.firstName + ' ' + this.collaborator.lastName;
    } else if (this.collaborator.fullName) {
      fullName = this.collaborator.fullName;
    }
    
    // Limiter la longueur si nécessaire
    if (this.maxLength > 0 && fullName.length > this.maxLength) {
      return fullName.substring(0, this.maxLength - 1) + '.';
    }
    
    return fullName;
  }

  /**
   * Vérifie si le collaborateur a un nom valide
   */
  hasValidName(): boolean {
    return !!(this.collaborator && this.getFormattedName().trim());
  }


  /**
   * Gère le clic sur le bouton collaborateur
   */
  onCollaboratorClick(event: Event): void {
    event.stopPropagation();
    
    if (this.disabled || !this.collaborator) {
      return;
    }

    // Émettre l'événement pour que le composant parent puisse gérer l'ouverture de modal
    this.collaboratorClick.emit({
      collaborator: this.collaborator,
      companyId: this.companyId,
      event
    });
  }

}
